import { render, staticRenderFns } from "./BalanceSheet.vue?vue&type=template&id=8049b664&scoped=true"
import script from "./BalanceSheet.vue?vue&type=script&lang=js"
export * from "./BalanceSheet.vue?vue&type=script&lang=js"
import style0 from "./BalanceSheet.vue?vue&type=style&index=0&id=8049b664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8049b664",
  null
  
)

export default component.exports